import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">{appData.title}</h2>
            <p className="text-sm text-background-400 mb-6">{appData.subtitle}</p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-6">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 text-xs text-background-300 bg-background-800/50 px-3 py-1.5 rounded-full whitespace-nowrap"
                >
                  <i className="ri-check-line text-accent-500 text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white text-sm font-semibold rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-accent-600 active:scale-95"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-800 text-background-200 text-sm font-semibold rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-background-700 active:scale-95"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 bg-white rounded-2xl flex items-center justify-center border-4 border-accent-500/30">
              <div className="text-center">
                <i className="ri-qr-code-line text-5xl md:text-6xl text-foreground-800"></i>
                <p className="text-xs text-foreground-500 mt-2 font-medium">{appData.qrCodeText}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}